export default "__VITE_ASSET__BnqX6Ow6__"